import React from 'react';
import { useNavigate } from 'react-router-dom';

const C = {
  dark: '#0a1628',
  white: '#ffffff',
  gray: '#8899aa',
  accent: '#0071BA',
  border: 'rgba(255,255,255,0.08)',
};

const s = {
  page: { minHeight: '100vh', backgroundColor: C.dark, color: C.white, fontFamily: 'Roboto, sans-serif', padding: '40px 20px' },
  container: { maxWidth: '760px', margin: '0 auto' },
  back: { background: 'none', border: 'none', color: C.gray, cursor: 'pointer', fontSize: '14px', marginBottom: '32px', padding: 0, display: 'flex', alignItems: 'center', gap: '6px' },
  logo: { fontSize: '22px', fontWeight: 800, color: C.white, marginBottom: '8px', letterSpacing: '2px' },
  title: { fontSize: '28px', fontWeight: 700, marginBottom: '8px' },
  updated: { fontSize: '13px', color: C.gray, marginBottom: '40px' },
  section: { marginBottom: '36px' },
  h2: { fontSize: '17px', fontWeight: 700, color: C.white, marginBottom: '12px', paddingBottom: '8px', borderBottom: `1px solid ${C.border}` },
  p: { fontSize: '15px', color: '#ccd6e0', lineHeight: '1.75', marginBottom: '12px' },
  ul: { paddingLeft: '20px', margin: '8px 0 12px' },
  li: { fontSize: '15px', color: '#ccd6e0', lineHeight: '1.75', marginBottom: '4px' },
  highlight: { color: C.white, fontWeight: 600 },
  link: { color: C.accent, textDecoration: 'none' },
  divider: { borderColor: C.border, margin: '40px 0' },
  contact: { backgroundColor: 'rgba(0,113,186,0.1)', border: `1px solid rgba(0,113,186,0.3)`, borderRadius: '12px', padding: '20px 24px' },
};

export default function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <div style={s.page}>
      <div style={s.container}>
        <button style={s.back} onClick={() => navigate(-1)}>← Torna indietro</button>

        <div style={s.logo}>OCTA</div>
        <h1 style={s.title}>Privacy Policy</h1>
        <p style={s.updated}>Ultimo aggiornamento: 4 maggio 2026</p>

        <div style={s.section}>
          <h2 style={s.h2}>1. Chi siamo</h2>
          <p style={s.p}>
            OCTA (Online Complete Travel Agency) è una piattaforma web per la pianificazione e condivisione di esperienze di viaggio.
            Il titolare del trattamento dei dati è <span style={s.highlight}>Federico Pasquetto</span>, raggiungibile all'indirizzo{' '}
            <a href="mailto:pasquettofederico@hotmail.it" style={s.link}>pasquettofederico@hotmail.it</a>.
          </p>
        </div>

        <div style={s.section}>
          <h2 style={s.h2}>2. Dati che raccogliamo</h2>
          <p style={s.p}>Raccogliamo i seguenti dati personali:</p>
          <ul style={s.ul}>
            <li style={s.li}><span style={s.highlight}>Dati di autenticazione:</span> indirizzo email, nome e foto profilo forniti tramite Google o Facebook Login</li>
            <li style={s.li}><span style={s.highlight}>Dati di profilo:</span> username scelto dall'utente, punteggio e livello sulla piattaforma</li>
            <li style={s.li}><span style={s.highlight}>Contenuti creati:</span> esperienze di viaggio pubblicate (destinazione, durata, costi, categorie)</li>
            <li style={s.li}><span style={s.highlight}>Dati di utilizzo:</span> interazioni con la piattaforma (es. esperienze copiate, visualizzazioni)</li>
          </ul>
        </div>

        <div style={s.section}>
          <h2 style={s.h2}>3. Come utilizziamo i tuoi dati</h2>
          <p style={s.p}>I dati raccolti vengono utilizzati per:</p>
          <ul style={s.ul}>
            <li style={s.li}>Permettere l'accesso e la gestione del tuo account</li>
            <li style={s.li}>Mostrare il tuo profilo e le tue esperienze ad altri utenti (se impostati come pubblici)</li>
            <li style={s.li}>Calcolare punteggi e livelli all'interno della piattaforma</li>
            <li style={s.li}>Migliorare i servizi offerti da OCTA</li>
          </ul>
          <p style={s.p}>Non utilizziamo i tuoi dati per profilazione a scopi commerciali né li vendiamo a terzi.</p>
        </div>

        <div style={s.section}>
          <h2 style={s.h2}>4. Servizi di terze parti</h2>
          <p style={s.p}>OCTA si avvale dei seguenti servizi esterni:</p>
          <ul style={s.ul}>
            <li style={s.li}><span style={s.highlight}>Supabase</span> — database e autenticazione. I dati sono archiviati su server sicuri. <a href="https://supabase.com/privacy" style={s.link} target="_blank" rel="noreferrer">Privacy Policy Supabase</a></li>
            <li style={s.li}><span style={s.highlight}>Google OAuth</span> — accesso tramite account Google. <a href="https://policies.google.com/privacy" style={s.link} target="_blank" rel="noreferrer">Privacy Policy Google</a></li>
            <li style={s.li}><span style={s.highlight}>Meta (Facebook) Login</span> — accesso tramite account Facebook. <a href="https://www.facebook.com/policy.php" style={s.link} target="_blank" rel="noreferrer">Privacy Policy Meta</a></li>
            <li style={s.li}><span style={s.highlight}>Vercel</span> — hosting dell'applicazione. <a href="https://vercel.com/legal/privacy-policy" style={s.link} target="_blank" rel="noreferrer">Privacy Policy Vercel</a></li>
          </ul>
        </div>

        <div style={s.section}>
          <h2 style={s.h2}>5. Conservazione dei dati</h2>
          <p style={s.p}>
            I tuoi dati vengono conservati per tutta la durata del tuo account. Puoi richiedere la cancellazione del tuo account e di tutti i dati associati in qualsiasi momento contattandoci all'indirizzo email indicato di seguito.
          </p>
        </div>

        <div style={s.section}>
          <h2 style={s.h2}>6. I tuoi diritti (GDPR)</h2>
          <p style={s.p}>Ai sensi del Regolamento UE 2016/679 (GDPR), hai diritto a:</p>
          <ul style={s.ul}>
            <li style={s.li}>Accedere ai tuoi dati personali</li>
            <li style={s.li}>Rettificare dati errati o incompleti</li>
            <li style={s.li}>Richiedere la cancellazione dei tuoi dati ("diritto all'oblio")</li>
            <li style={s.li}>Opporti al trattamento dei dati</li>
            <li style={s.li}>Richiedere la portabilità dei dati</li>
          </ul>
          <p style={s.p}>Per esercitare questi diritti, contattaci via email.</p>
        </div>

        <div style={s.section}>
          <h2 style={s.h2}>7. Cookie</h2>
          <p style={s.p}>
            OCTA utilizza esclusivamente cookie tecnici necessari al funzionamento dell'autenticazione e della sessione utente. Non vengono utilizzati cookie di profilazione o marketing.
          </p>
        </div>

        <div style={s.section}>
          <h2 style={s.h2}>8. Modifiche alla Privacy Policy</h2>
          <p style={s.p}>
            Ci riserviamo il diritto di aggiornare questa Privacy Policy. In caso di modifiche sostanziali, gli utenti registrati verranno informati. L'uso continuato della piattaforma dopo le modifiche costituisce accettazione della nuova policy.
          </p>
        </div>

        <hr style={s.divider} />

        <div style={s.contact}>
          <p style={{ ...s.p, marginBottom: 4, fontWeight: 600, color: C.white }}>Contatti</p>
          <p style={{ ...s.p, marginBottom: 0 }}>
            Per qualsiasi domanda sulla privacy, scrivi a{' '}
            <a href="mailto:pasquettofederico@hotmail.it" style={s.link}>pasquettofederico@hotmail.it</a>
          </p>
        </div>
      </div>
    </div>
  );
}
